"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleEnumReverse = exports.roleEnum = void 0;
const roleEnum = {
  DISTILLERY_ADMIN: 1,
  EXPERIMENTER: 2,
  EXPERIMENTER_ADMIN: 3,
  EXPERIMENTER_TECH: 4,
  PRODUCT_OWNER: 5,
  QUANTUM_API: 6,
  ALL_PRODUCTS_EXPERIMENTER: 7,
  ALL_PRODUCTS_OBSERVER: 8,
  PRODUCT_OPERATIONS: 9,
  VIEW_ONLY: 10,
  ROKU_PERSONNEL: 11,
  ANDROID_PERSONNEL: 12,
  SAMSUNG_PERSONNEL: 13,
  SPECTRUM_GUIDE_PERSONNEL: 14,
  TVOS_PERSONNEL: 15,
  WATCH_SPECTRUM_PERSONNEL: 16,
  XBOX_TVSDK_PERSONNEL: 17,
  XBOX_PERSONNEL: 18,
  IOS_PERSONNEL: 19,
  SPECTRUM_NET_PERSONNEL: 20,
  SPECTRUMBUSINESS_NET_PERSONNEL: 22,
  MYSPECTRUM_ANDROID_PERSONNEL: 23,
  MYSPECTRUM_IOS_PERSONNEL: 24,
  MYSPECTRUMMOBILE_ANDROID_PERSONNEL: 25,
  MYSPECTRUMMOBILE_IOS_PERSONNEL: 26,
  PRODUCT_OPERATIONS_PERSONNEL: 27,
  DISTILLERY_SUPPORT_PERSONNEL: 28,
  STVA_PLATFROM_ADMIN: 29,
  DASP_PLATFORM_ADMIN: 30,
  ROKU_RSG_PERSONNEL: 31,
  CHROMECAST_PERSONNEL: 32,
  QUANTUM_PERSONNEL: 33,
  PORTFOLIO_OWNER: 34,
  EXPERIMENT_EVALUATOR: 35,
  AD_HOC_EXPERIMENT_EVALUATOR: 36,
  CMS_EXPERIMENTER: 37,
  FIRETV_PERSONNEL: 38,
  CONTENT_MAP_APPROVER: 39,
  EXPERIMENTER_DATA_SCIENCE: 40,
  IDM_PERSONNEL: 41,
  MUTUALLY_EXCLUSIVE_EXPERIMENTER: 42,
  NETWORK_LOCKDOWN_ADMIN: 43
};
exports.roleEnum = roleEnum;
const roleEnumReverse = {
  1: 'DISTILLERY_ADMIN',
  2: 'EXPERIMENTER',
  3: 'EXPERIMENTER_ADMIN',
  4: 'EXPERIMENTER_TECH',
  5: 'PRODUCT_OWNER',
  6: 'QUANTUM_API',
  7: 'ALL_PRODUCTS_EXPERIMENTER',
  8: 'ALL_PRODUCTS_OBSERVER',
  9: 'PRODUCT_OPERATIONS',
  10: 'VIEW_ONLY',
  11: 'ROKU_PERSONNEL',
  12: 'ANDROID_PERSONNEL',
  13: 'SAMSUNG_PERSONNEL',
  14: 'SPECTRUM_GUIDE_PERSONNEL',
  15: 'TVOS_PERSONNEL',
  16: 'WATCH_SPECTRUM_PERSONNEL',
  17: 'XBOX_TVSDK_PERSONNEL',
  18: 'XBOX_PERSONNEL',
  19: 'IOS_PERSONNEL',
  20: 'SPECTRUM_NET_PERSONNEL',
  22: 'SPECTRUMBUSINESS_NET_PERSONNEL',
  23: 'MYSPECTRUM_ANDROID_PERSONNEL',
  24: 'MYSPECTRUM_IOS_PERSONNEL',
  25: 'MYSPECTRUMMOBILE_ANDROID_PERSONNEL',
  26: 'MYSPECTRUMMOBILE_IOS_PERSONNEL',
  27: 'PRODUCT_OPERATIONS_PERSONNEL',
  28: 'DISTILLERY_SUPPORT_PERSONNEL',
  29: 'STVA_PLATFROM_ADMIN',
  30: 'DASP_PLATFORM_ADMIN',
  31: 'ROKU_RSG_PERSONNEL',
  32: 'CHROMECAST_PERSONNEL',
  33: 'QUANTUM_PERSONNEL',
  34: 'PORTFOLIO_OWNER',
  35: 'EXPERIMENT_EVALUATOR',
  36: 'AD_HOC_EXPERIMENT_EVALUATOR',
  37: 'CMS_EXPERIMENTER',
  38: 'FIRETV_PERSONNEL',
  39: 'CONTENT_MAP_APPROVER',
  40: 'EXPERIMENTER_DATA_SCIENCE',
  41: 'IDM_PERSONNEL',
  42: 'MUTUALLY_EXCLUSIVE_EXPERIMENTER',
  43: 'NETWORK_LOCKDOWN_ADMIN'
};
exports.roleEnumReverse = roleEnumReverse;